import {
  type DocumentMutationPayload,
  type DocumentMutationResponse,
  type IDecryptDataDocumentRequest,
  type NycLookupLicenseParams,
  type NycLookupLicenseResponse,
} from '../documents.types'

import { ENDPOINTS_TAGS, rootApi } from '@v2/store/api/rootApi'

const personTags = (personId: string) => [
  { type: ENDPOINTS_TAGS.PERSON, id: personId },
]

export const documentsApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    createDocument: builder.mutation<
      DocumentMutationResponse,
      DocumentMutationPayload
    >({
      query: (data) => ({
        url: '/v2/person/documents',
        method: 'POST',
        data,
      }),
      invalidatesTags: (_, __, { personId }) => personTags(personId),
    }),

    updateDocument: builder.mutation<
      DocumentMutationResponse,
      DocumentMutationPayload
    >({
      query: (data) => ({
        url: '/v2/person/documents',
        method: 'PATCH',
        data,
      }),
      invalidatesTags: (_, __, { personId }) => personTags(personId),
    }),

    deleteDocument: builder.mutation<
      { OK: boolean },
      { documentId: string; personId: string }
    >({
      query: ({ documentId }) => ({
        url: `/person/documents/${documentId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_, __, { personId }) => personTags(personId),
    }),

    getNycLookupLicense: builder.query<
      NycLookupLicenseResponse,
      NycLookupLicenseParams
    >({
      query: ({ findBy, findValue }) => ({
        url: '/v2/nyc-open-data/lookup',
        method: 'GET',
        params: {
          findBy: findBy?.trim(),
          findValue: findValue?.trim(),
        },
      }),
    }),

    decryptDocumentData: builder.mutation<string, IDecryptDataDocumentRequest>({
      query: ({ documentId }) => ({
        url: `/v2/person/documents/${documentId}/number/decrypt`,
        method: 'POST',
      }),
    }),
  }),
})

export const {
  useCreateDocumentMutation,
  useUpdateDocumentMutation,
  useDeleteDocumentMutation,
  useGetNycLookupLicenseQuery,
  useDecryptDocumentDataMutation,
} = documentsApi
